import { buildQueryString } from "../helper/utils/utils";

interface AppRoutes {
  auth: {
    base: string;
    title: string;
    login: string;
    forgotPassword: string;
    changePassword: string;
    resetPassword: string;
  };
  employer: {
    base: string;
    title: string;
    list: string;
    details: string;
    detailsWithId: (id: number | string) => (string | number)[];
  };
  agent: {
    base: string;
    title: string;
    list: string;
    details: string;
    detailsWithId: (id: number | string) => (string | number)[];
  };
  admin: {
    base: string;
    title: string;
    list: string;
    details: string;
    detailsWithId: (id: number | string) => (string | number)[];
  };
  payroll: {
    base: string;
    title: string;
    list: string;
    details: string;
    add: string;
    edit: string;
    detailsWithId: (id: number | string) => (string | number)[];
  };
  commissions: {
    base: string;
    title: string;
    list: string;
    details: string;
    detailsWithQuery: (params?: Record<string, string | number>) => string;
    subemployerCommissions:string;
    subEmployerDetailsWithQuery: (params?: Record<string, string | number>) => string;
    employeeCommissions:string;
    employeeCommissionWithQuery: (params?: Record<string, string | number>) => string;
  };
  settings: {
    base: string;
    title: string;
    list: string;
    details: string;
    detailsWithId: (id: number | string) => (string | number)[];
  };
  fallback: {
    base: string;
    title: string;
    default: string;
    notFound: string;
  };
}

export const APP_ROUTES: AppRoutes = {
  auth: {
    base: 'auth',
    title: 'Authentication',
    login: 'login',
    forgotPassword: 'forgot-password',
    changePassword: 'change-password',
    resetPassword: 'reset-password',
  },
  employer: {
    base: 'employer',
    title: 'Employers',
    list: 'list',
    details: ':id',
    detailsWithId: (id: number | string) => ['employer', id],
  },
  agent: {
    base: 'agent',
    title: 'Agents',
    list: 'list',
    details: ':id',
    detailsWithId: (id: number | string) => ['agent', id],
  },
  admin: {
    base: 'admin',
    title: 'Manage Admins',
    list: 'list',
    details: ':id',
    detailsWithId: (id: number | string) => ['admin', id],
  },
  payroll: {
    base: 'payroll',
    title: 'Payroll Actuals',
    list: 'list',
    add: "add",
    edit: "edit",
    details: ':id',
    detailsWithId: (id: number | string) => ['edit', id],
  },
  commissions: {
    base: 'commissions',
    title: 'Commissions',
    list: 'list',
    details: 'commission-details',
    subemployerCommissions: 'subemployer-commission-details',
    detailsWithQuery: (params?: Record<string, string | number>) =>`commission-details${buildQueryString(params)}`,
    subEmployerDetailsWithQuery: (params?: Record<string, string | number>) =>`subemployer-commission-details${buildQueryString(params)}`,
    employeeCommissions: 'employee-commission-details',
    employeeCommissionWithQuery: (params?: Record<string, string | number>) =>`employee-commission-details${buildQueryString(params)}`, 
  },
  settings: {
    base: 'settings',
    title: 'Settings',
    list: 'list',
    details: ':id',
    detailsWithId: (id: number | string) => ['settings', id],
  },
  fallback: {
    base: '',
    title: 'Home',
    default: '',
    notFound: '**',
  },
};